import React, { memo, useState } from 'react';
import { Upload, message, Modal } from 'antd';
import type { UploadFile } from 'antd/es/upload/interface';
import { PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';

interface CarImagesUploadProps {
  onChange?: (files: string[]) => void;
}

const CarImagesUpload = memo(({ onChange }: CarImagesUploadProps) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  const handleChange = async ({ fileList }: { fileList: UploadFile[] }) => {
    if (fileList.length > 4) {
      message.warning('Зөвхөн 4 зураг оруулна уу');
      return;
    }
    setFileList(fileList);

    const urls = await Promise.all(
      fileList.map(async (file) => {
        if (file.originFileObj) {
          return URL.createObjectURL(file.originFileObj);
        }
        return file.url || '';
      })
    );

    onChange?.(urls.filter(Boolean));
  };

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as File);
        reader.onload = () => resolve(reader.result as string);
      });
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewVisible(true);
    setPreviewTitle(file.name || 'Зураг');
  };

  return (
    <Container>
      <div className="border border-gray-300 p-6 rounded-lg bg-white">
        <div className="text-lg font-semibold text-gray-800 mb-2">Машины зураг оруулна уу</div>
        <div className="text-sm text-gray-600 mb-4">Урд тал · Хойд тал · Зүүн тал · Баруун тал</div>

        <Upload
          listType="picture-card"
          fileList={fileList}
          onChange={handleChange}
          onPreview={handlePreview}
          beforeUpload={() => false}
          multiple
          maxCount={4}
        >
          {fileList.length >= 4 ? null : (
            <div>
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>Зураг сонгох</div>
            </div>
          )}
        </Upload>

        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={() => setPreviewVisible(false)}
        >
          <img alt="preview" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    </Container>
  );
});

const Container = styled.div``;

CarImagesUpload.displayName = 'CarImagesUpload';

export { CarImagesUpload };
